import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/main.vue'
// import Resources from '../views/resource-list.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/resource-list',
    name: 'Resources',
    component: () => import('../views/resource-list.vue')
  },
  {
    path: '/resource-handbook',
    name: 'Resource Handbook',
    component: () => import('../views/resource-handbook.vue')
  },
  {
    path: '/resource-visits',
    name: 'Resource Visits',
    component: () => import('../views/resource-visits.vue')
  },
  {
    path: '/cd-visit-planner',
    name: 'CD Visit Planner',
    component: () => import('../views/cd-visit-planner.vue')
  },
  {
    path: '/uc-visit-planner',
    name: 'UC Visit Planner',
    component: () => import('../views/uc-visit-planner.vue')
  },
  {
    path: '/resource-accomadations',
    name: 'Accommodations Toolkit',
    component: () => import('../views/resource-accomadations.vue')
  },
  {
    path: '/resource-meal-plan',
    name: 'Healthy Meal plan for IBD',
    component: () => import('../views/resource-meal-plan.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/support.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
      document.getElementById('app').scrollIntoView();
  } 
})

export default router
